import AddressModalEdit from "../modal/AddressModalEdit";
import React, {useState} from "react";
import AddressListModal from "./AddressListModal";

function DefaultAddressCard({addresses, item,setSelected, setRefreshAddresses, setDefaultAddress, selected}){
    const [openAddressModal, setOpenAddressModal] = useState(false)

    const onClose= () => {
        setOpenAddressModal(false)
    }
    return (
        <div className="address-item">
            <div className="address-icon">
                <i className="fas fa-home"></i>
            </div>
            <div className="address-details">
                <div className="address-name">{item.name}</div>
                <div className="address-text">
                    {item.addressLine1} {item.addressLine2 && `, ${item.addressLine2}`}, {item.district}, {item.state}, {item.country}-{item.zip}
                </div>
                <div className="address-text">Mobile: {item.mobile}</div>
                <div className="address-text">Email: {item.email}</div>
            </div>
            {addresses?.length >=1 && (
                <>
                    <button className="address-edit" onClick={() => setOpenAddressModal(true)}>
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </>
            )}
            {
                openAddressModal && <AddressListModal selected={selected} addresses={addresses} setSelected={setSelected} onClose ={onClose} setRefreshAddresses={setRefreshAddresses} setDefaultAddress={setDefaultAddress} />
            }
        </div>
    )
}
export default DefaultAddressCard;